import React from 'react';
import { Link } from 'components';
import Logo from '../../../assets/icons/logo';

export default ({ className }) => (
  <Link ariaLabel="logo_header" to="/">
    <Logo className={className} />
  </Link>
);
